import { register } from "@shopify/theme-sections";
import Slider from "../components/slider/slider";

const selectors = {
	slider: "[data-collections-slider]",
	arrowNext: "[data-slider-arrow-next]",
	arrowPrev: "[data-slider-arrow-prev]",
	pagination: "[data-slider-pagination]"
};

register("collections-slider", {
	slider: null,
	options: {},
	onLoad: function () {
		this.sliderContainer = this.container.querySelector(selectors.slider);

		if (!this.sliderContainer) {
			return null;
		}

		this.options = {
			sliderPerView: "auto",
			spaceBetween: 10,
			autoplay: false,
			navigation: {
				nextEl: selectors.arrowNext,
				prevEl: selectors.arrowPrev
			},
			pagination: {
				el: selectors.pagination,
				clickable: true,
				type: "bullets"
			},
			isArrowOutside: true
		};

		this.slider = new Slider(this.sliderContainer, this.options);
	},
	onUnload: function () {
		if (!this.slider) {
			return null;
		}

		this.slider.destroy();
	},
	getInstance: function () {
		return this.slider.instance;
	}
});
